import { IsAlphanumeric, MaxLength, Matches, IsOptional, IsNotEmpty } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';
import { LeaveApprovalStatusEnum } from '@gtpl/shared-models/common-models';

export class OverTimeDTO {
    @ApiProperty()
    otId: number;

    @ApiProperty()
    employeeCode: string;

    @ApiProperty()
    employeeName: string;

    @ApiProperty()
    date: string;

    @ApiProperty()
    inTime: Date;

    @ApiProperty()
    outTime: Date;

    @ApiProperty()
    workingHours: number;

    @ApiProperty()
    otType: string;

    @ApiProperty()
    otHours: any;

    @ApiProperty()
    status: LeaveApprovalStatusEnum;

    @ApiProperty()
    month: number;

    @ApiProperty()
    @IsOptional()
    @MaxLength(40, { message: "Created User allows maximum 40 characters" })
    createdUser: string;

    @ApiProperty()
    @IsOptional()
    @MaxLength(40, { message: "Updated User allows maximum 40 characters" })
    updatedUser: string;

}